import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import StorefrontIcon from "@material-ui/icons/Storefront";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import CircularProgress from "@material-ui/core/CircularProgress";

import ImageGelombang from "../../../assets/images/login-gelombang.svg";
import Navbar from "../../../components/molecules/navbarLogReg";
import ImageFamily from "../../../assets/images/family.svg";
import useStyles from "./style";
import {
  subdomainsCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router";
import {
  auth,
  FieldValue,
} from "../../../components/firebase/FirebaseProvider";

const NumberFormatCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        /[1-9]/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default function Info() {
  const classes = useStyles();
  const theme = useTheme();
  const matches1 = useMediaQuery(theme.breakpoints.up("1027"));
  const matches = useMediaQuery(theme.breakpoints.up("951"));
  const [year] = useState(new Date().getFullYear());

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const { webstoreRef, profil, webstore, phone } = useData();

  const [values, setValues] = useState({
    domain: "",
    nama: "",
    // wa: "",
  });
  const [error, setError] = useState({
    domain: "",
    nama: "",
    // wa: "",
  });
  // const handleChange = (e) => {
  //   const value = e.target.value;
  //   let name = e.target.name

  //   if (name === "domain") {
  //     name = value.replace(' ', '-')
  //     name = value.toLowerCase()
  //   }

  //   setValues({ ...values, [name]: value });
  //   setError({ ...error, [name]: "", });
  // };

  const handleChange = (e) => {
    const value = e.target.value;
    let name = e.target.name;

    setValues(() => {
      if (name === "domain") {
        if (" ") {
          return { ...values, [name]: value.replace(" ", "-") };
        }
        return { ...values, [name]: value.toLocaleLowerCase() };
      } else {
        return { ...values, [name]: value };
      }
    });

    setError({
      ...error,
      [name]: "",
    });
  };

  const [isSubmitting, setSubmitting] = useState(false);

  const checkDomain = async () => {
    const x = await subdomainsCollection.doc(values.domain).get();
    return x.exists;
  };

  const validate = async () => {
    const exp = /-/g;
    const reqDomain = /^[a-z0-9-]{3,20}$/g;
    const newError = { ...error };
    let exist;

    if (!values.nama) {
      newError.nama = "Nama harus diisi";
    } else if (values.nama.length < 3) {
      newError.nama = "Nama toko minimal 3 karakter";
    }

    // if (!values.wa) {
    //   newError.wa = "No WhatsApp wajib diisi";
    // } else if (!isMobilePhone(values.wa.replace(exp, ""))) {
    //   newError.wa = "No Whatsapp tidak valid";
    // }

    if (!values.domain) {
      newError.domain = "Domain harus diisi";
    } else if (values.domain.length < 3) {
      newError.domain = "Domain toko minimal 3 karakter";
    } else if (values.domain.length > 20) {
      newError.domain = "Domain toko maximal 20 karakter";
    } else if (!reqDomain.test(values.domain)) {
      newError.domain = "Domain hanya boleh terdiri dari huruf kecil dan angka";
    } else {
      exist = await checkDomain();
      if (exist) {
        newError.domain = "Domain sudah digunakan";
      }
    }
    return newError;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let exp = /-/g;
    const findError = await validate();

    console.log(findError);
    if (Object.values(findError).some((m) => m !== "")) {
      setError(findError);
    } else {
      setSubmitting(true);
      // console.log("ini ", {...values });
      try {
        // let newWebstore = { ...values };
        // const { wa } = values;
        // const newPhone = wa.replace(exp, "");

        await webstoreRef.set(
          {
            ...values,
            wa: phone.id,
            created_at: FieldValue.serverTimestamp(),
            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
        await subdomainsCollection.doc(values.domain).set({
          user_id: profil.id,
          created_at: FieldValue.serverTimestamp(),
          updated_at: FieldValue.serverTimestamp(),
        });

        history.replace(`/`);
        enqueueSnackbar("Info Toko Berhasi ditambahkan", {
          variant: "success",
        });
      } catch (e) {
        const newError = {};
        newError.title = e.message;
        // console.log("error", error);
        setError(newError);
      }
      setSubmitting(false);
    }
  };

  const handleSignOut = async () => {
    await auth.signOut();
  };

  useEffect(() => {
    // console.log(webstore?.domain)
    if (webstore?.domain) {
      history.push(`/`);
    }
  }, []);

  return (
    <div>
      <div className={classes.header}>
        <Navbar />
        <div>
          <div>
            <img
              src={ImageGelombang}
              alt="icon"
              className={classes.gelombang}
            />
          </div>
          {matches ? (
            <div
              style={{
                margin: "5%",
                marginLeft: "10%",
              }}
            >
              <img
                src={ImageFamily}
                alt="icon"
                style={{ width: "30%", position: "absolute" }}
              />
            </div>
          ) : null}
          <div>
            <div className={classes.content}>
              <div className={classes.boxContent}>
                <div className={classes.textContent3}>
                  <h4 className={classes.textContent4}>Info Toko</h4>
                </div>
                <div className={classes.garisContent} />
                <values noValidate autoComplete="off">
                  <FormControl variant="outlined" style={{ width: "90%" }}>
                    <InputLabel
                      htmlFor="outlined-adornment-amount"
                      style={{ fontWeight: "bold", color: "#000000a8" }}
                      slot="true"
                    >
                      Nama Toko
                    </InputLabel>
                    <OutlinedInput
                      label="Nama Toko"
                      id="nama"
                      name="nama"
                      disabled={isSubmitting}
                      placeholder="Aisyah Shop"
                      onChange={handleChange}
                      error={error.nama ? true : false}
                      helperText={error.nama}
                      value={values.nama}
                      startAdornment={
                        <InputAdornment position="start">
                          <StorefrontIcon color="action" />
                        </InputAdornment>
                      }
                      labelWidth={0}
                    />
                  </FormControl>
                  <p
                    style={{
                      fontSize: "9px",
                      color: "red",
                      alignItems: "center",
                      textAlign: "left",
                      marginTop: 5,
                      marginBottom: -5,
                      marginLeft: "5%",
                      display: "flex",
                      fontWeight: "500",
                      width: "300px",
                    }}
                  >
                    {error.nama}
                  </p>
                  <p
                    style={{
                      fontSize: "9px",
                      alignItems: "center",
                      textAlign: "left",
                      marginTop: 16,
                      marginBottom: -5,
                      marginLeft: "5%",
                      marginRight: "15%",
                      display: "flex",
                      fontWeight: "500",
                      width: "300px",
                    }}
                  >
                    Nama domain hanya boleh terdiri dari huruf dan angka saja,
                    tidak boleh mengandung tanda khusus berikut ( ! @ # $ % ^ &
                    * _ + ~ )
                  </p>
                  <FormControl
                    variant="outlined"
                    style={{ width: "90%", marginTop: error.nama ? 15 : 20 }}
                  >
                    <InputLabel
                      htmlFor="outlined-adornment-amount"
                      style={{ fontWeight: "bold", color: "#000000a8" }}
                      slot="true"
                    >
                      Domain Toko
                    </InputLabel>
                    <OutlinedInput
                      label="Domain Toko "
                      id="domain"
                      name="domain"
                      placeholder="aisyah"
                      disabled={isSubmitting}
                      error={error.domain ? true : false}
                      helperText={error.domain}
                      value={values.domain}
                      onChange={handleChange}
                      startAdornment={
                        <InputAdornment position="start">
                          <StorefrontIcon color="action" />
                        </InputAdornment>
                      }
                      labelWidth={0}
                    />
                  </FormControl>
                  <p
                    style={{
                      fontSize: "9px",
                      color: "red",
                      alignItems: "center",
                      textAlign: "left",
                      marginTop: 5,
                      marginBottom: -5,
                      marginLeft: "5%",
                      display: "flex",
                      fontWeight: "500",
                      width: "300px",
                    }}
                  >
                    {error.domain}
                  </p>
                  {/* <FormControl
                    variant="outlined"
                    style={{ width: "90%", marginTop: 20 }}
                  >
                    <InputLabel
                      htmlFor="outlined-adornment-amount"
                      style={{ fontWeight: "bold", color: "#000000a8" }}
                      slot="true"
                    >
                      No Kontak / WA Toko
                    </InputLabel>
                    <OutlinedInput
                      label="No Kontak / WA Toko"
                      id="wa"
                      name="wa"
                      disabled={isSubmitting}
                      error={error.wa ? true : false}
                      helperText={error.wa}
                      value={values.wa}
                      placeholder="+62-852-1234-5678"
                      onChange={handleChange}
                      startAdornment={
                        <InputAdornment position="start">
                          <WhatsAppIcon color="action" />
                        </InputAdornment>
                      }
                      labelWidth={0}
                      inputComponent={NumberFormatCustom}
                    />
                  </FormControl>
                  <p
                    style={{
                      fontSize: "9px",
                      color: "red",
                      alignItems: "center",
                      textAlign: "left",
                      marginTop: 5,
                      marginBottom: -5,
                      marginLeft: "5%",
                      display: "flex",
                      fontWeight: "500",
                      width: "300px",
                    }}
                  >
                    {error.wa}
                  </p> */}
                </values>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.formBottom}
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                >
                  {isSubmitting === true ? (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  ) : (
                    "Simpan Info Toko "
                  )}
                </Button>
                <Button
                  color="primary"
                  className={classes.formBottom1}
                  style={{ marginBottom: "3%" }}
                  onClick={handleSignOut}
                >
                  Sign Out
                </Button>
              </div>
            </div>
            <div className={classes.textCopyright}>
              {matches1 ? (
                <h5 className={classes.textCopyrightH5}>
                  Copyright © TokoRame {year}
                </h5>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
